import script from "./IpOSViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IpOSViewPage.vue?vue&type=script&setup=true&lang=js"

import "./IpOSViewPage.vue?vue&type=style&index=0&id=67c9e130&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c9e130"]])

export default __exports__